module.exports = __webpack_public_path__ + "img/mycar-record.07cd297e.png";